import { Mail, Phone, MapPin, Instagram, Facebook } from "lucide-react";
import { useTranslation } from "../../i18n/LanguageContext";

export default function Footer() {
  const { t } = useTranslation();
  const f = t.footer;
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#dfd3ee] border-t border-white/5 pt-14 md:pt-20 pb-8 md:pb-10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12 pb-8 md:pb-12 border-b border-white/5">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3.5">
              <img
                src="/logo.png"
                alt={t.nav.brand}
                className="h-14 md:h-16 w-auto object-contain drop-shadow-[0_2px_10px_rgba(0,0,0,0.3)]"
              />
              <div>
                <div className="font-brand text-xl md:text-2xl uppercase gold-text">
                  {t.nav.brand}
                </div>
                <div className="font-brand-sub text-[10px] md:text-[11px] uppercase text-[#0a0a0a]/90 mt-1">
                  {t.nav.brandSub}
                </div>
              </div>
            </div>
            <p className="mt-6 text-[#8a7f8f] leading-relaxed max-w-md text-sm">
              {f.about}
            </p>

            <div className="mt-7 flex gap-3">
              <a
                data-testid="footer-instagram"
                href="#"
                aria-label="Instagram"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-[#594f5a] hover:border-[#0a0a0a] hover:text-[#0a0a0a] transition-colors"
              >
                <Instagram size={15} />
              </a>
              <a
                data-testid="footer-facebook"
                href="#"
                aria-label="Facebook"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-[#594f5a] hover:border-[#0a0a0a] hover:text-[#0a0a0a] transition-colors"
              >
                <Facebook size={15} />
              </a>
            </div>
          </div>

          <div>
            <div className="text-eyebrow mb-5">{f.menu}</div>
            <ul className="space-y-3 text-sm text-[#594f5a]">
              {f.links.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="hover:text-[#1a1a1a]">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-eyebrow mb-5">{f.contact}</div>
            <ul className="space-y-3 text-sm text-[#594f5a]">
              <li className="flex items-start gap-2">
                <Mail size={14} className="text-[#0a0a0a] mt-0.5 shrink-0" />
                <a
                  href="mailto:korona.tours555@gmail.com"
                  className="hover:text-[#1a1a1a]"
                >
                  korona.tours555@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Phone size={14} className="text-[#0a0a0a] mt-0.5 shrink-0" />
                <a href="tel:+36306278654" className="hover:text-[#1a1a1a]">
                  +36 30 627 8654
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={14} className="text-[#0a0a0a] mt-0.5 shrink-0" />
                <span>{f.addr}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-[#8a7f8f]">
          <div>
            © {new Date().getFullYear()} Korona Tours &amp; Travel · {f.rights}
          </div>
          <div className="flex gap-5">
            {f.legal.map((l) => (
              <a key={l} href="#" className="hover:text-[#1a1a1a]">
                {l}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
